import axios from "axios";
import { currentEnv } from "~/configs";
const RESTFULL_API_URL = currentEnv.RESTFULL_API_URL;
axios.defaults.baseURL = RESTFULL_API_URL;
